
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wrapped",
      function () {
        return require("private-next-pages/wrapped.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wrapped"])
      });
    }
  